import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface BankTransactionSuccessCardProps {
  result: {
    id: string;
    status: string;
    amount: string;
  };
  data: {
    transaction_id: string;
    order_id: string;
    acquirer_name: string;
    transaction_type: string;
    source: string;
    receipt_number: string;
    date: string;
    time: string;
  };
}

const BankTransactionSuccessCard: React.FC<BankTransactionSuccessCardProps> = ({
  result,
  data,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <Card className="max-w-md w-full bg-white rounded-2xl shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-green-600 mb-2">
              Payment Successful!
            </h1>
            <p className="text-gray-600">
              Your payment has been processed successfully.
            </p>
          </div>

          {/* <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              Transaction Details
            </h2>
            <div className="space-y-3 text-left">
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">Amount:</span>
                <span className="text-gray-900">PKR {result.amount}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">Order ID:</span>
                <span className="text-gray-900">{data.order_id}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">
                  Transaction ID:
                </span>
                <span className="text-gray-900">{data.transaction_id}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">Date:</span>
                <span className="text-gray-900">
                  {data.slot_date} {data.time}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">Status:</span>
                <span className="text-gray-900">{result.status}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">Card Brand:</span>
                <span className="text-gray-900">{data.source}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold text-gray-600">
                  Transaction Type:
                </span>
                <span className="text-gray-900">{data.transaction_type}</span>
              </div>
            </div>
          </div> */}
        </CardContent>
      </Card>
    </div>
  );
};

export default BankTransactionSuccessCard;
